const questions = document.querySelectorAll('.question');

if (questions) {
    [...questions].forEach((question) => {
        question.querySelector('h6').addEventListener('click', () => {
            if (question.classList.contains('is-open')) {
                question.classList.remove('is-open');
            } else {
                question.classList.add('is-open');
            }
        })
    })
}